module.exports = __webpack_public_path__ + "img/diy-SiYu.d31c8525.svg";